module.exports = __webpack_public_path__ + "static/media/ilbc2.c790df71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ilbc2.jpg
// module id = 5800
// module chunks = 0